module.exports = __webpack_public_path__ + "img/consult_top_bg.f3a2fb22.png";